// extracted by mini-css-extract-plugin
export default {"main-content":"DepreciationCollectionManagementTable_main-content__qWPOt","textLink":"DepreciationCollectionManagementTable_textLink__WcF2Y"};